// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3elEU","rightAdornment":"Header_rightAdornment__1HuFa"};